// extracted by mini-css-extract-plugin
export default {"notification-item":"Z6vcr","notification-item_pointer":"amjtl","notification-card":"lL3sp","main":"US3so","action-button":"bJnLo","text":"T1p5c"};